import { CommonModule } from '@angular/common';
import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { getEntityConfig, type EntityConfig } from '../../config/entity-config';
import { EntityListPageComponent } from '../entity-list/entity-list-page.component';

/**
 * Route component for /manage/:entityKey. Resolves entity config and renders
 * custom list component or default EntityListPageComponent.
 */
@Component({
  selector: 'app-management-list',
  standalone: true,
  imports: [CommonModule, EntityListPageComponent],
  template: `
    @if (entityConfig(); as config) {
      @if (config.listComponent) {
        <ng-container *ngComponentOutlet="config.listComponent; inputs: { entityConfig: config }" />
      } @else {
        <app-entity-list-page [entityConfig]="config" />
      }
    } @else {
      <p>Unknown entity.</p>
    }
  `,
})
export class ManagementListComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private sub: Subscription | null = null;
  readonly entityConfig = signal<EntityConfig | undefined>(undefined);

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe((params) => {
      const key = params.get('entityKey') ?? '';
      this.entityConfig.set(getEntityConfig(key));
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
